import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./ResendVerifyEmail.css";
import { forgotPassword } from "../../util/APIUtils";
import Alert from "react-s-alert";

function ResendVerifyEmail() {
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  // get email in url every component render
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("email")) {
      setUserEmail(params.get("email"));
    }
  }, []);

  const resendOTP = () => {
    const forgotPasswordRequest = Object.assign({}, { email: userEmail });

    forgotPassword(forgotPasswordRequest)
      .then((response) => {
        Alert.success(
          "Resend email success. Please check your email to verify your account"
        );
      })
      .catch((error) => {
        Alert.error(
          (error && error.message) ||
            "Oops! Something went wrong. Please try again!"
        );
      });

    setMinutes(1);
    setSeconds(0);
  };

  return (
    <div className="signup-container">
      <div className="signup-content">
        <h1 className="signup-title">Reset Account Password</h1>
        <h3 className="signup-title">Check email for reset link</h3>
        <h5 className="signup-title">
          An email has ben sent to the administrative email address on file.
          Check the inbox of the administrator's email account, an click the
          reset link provided.
        </h5>
        <h5>
          Reset link will become invalid in
          <p>
            Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:{" "}
            {seconds < 10 ? `0${seconds}` : seconds}{" "}
          </p>
        </h5>
        <div className="or-separator">
          <span className="or-text">OR</span>
        </div>
        <span>
          Didn't receive an email?
          <button
            className="button-resend-email"
            disabled={seconds > 0 || minutes > 0}
            style={{
              color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
            }}
            onClick={resendOTP}
          >
            Resend Email
          </button>
        </span>
      </div>
    </div>
  );
}

export default ResendVerifyEmail;



// WEBPACK FOOTER //
// ./src/user/resend_verify_email/ResendVerifyEmail.js